module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_row",
    class: {
      'has-success': _vm.success && _vm.isRequired, 'has-error': !_vm.success && _vm.isRequired
    }
  }, [_c('div', {
    staticClass: "item left",
    class: {
      'required': _vm.isRequired
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.capitalize(_vm.translateMessage(_vm.placeholder)))
    }
  }), _vm._v(" "), (_vm.inline) ? _c('div', [_c('span', {
    staticClass: "select_right pad_t5"
  }, _vm._l((_vm.data), function(item) {
    return _c('span', {
      key: item.key
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      staticClass: "checkbox",
      attrs: {
        "name": _vm.name,
        "disabled": _vm.isDisabled,
        "type": "checkbox"
      },
      domProps: {
        "value": item.key,
        "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, item.key) > -1 : (_vm.newValue)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.newValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "marg_r20",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.capitalize(_vm.translateMessage(item.value)))
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.inline) ? _c('div', _vm._l((_vm.data), function(item) {
    return _c('span', {
      key: item.key,
      staticClass: "select_right pad_t5"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newValue),
        expression: "newValue"
      }],
      staticClass: "checkbox",
      attrs: {
        "name": _vm.name,
        "disabled": _vm.isDisabled,
        "type": "checkbox"
      },
      domProps: {
        "value": item.key,
        "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, item.key) > -1 : (_vm.newValue)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.newValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.newValue = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "marg_r20",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.capitalize(_vm.translateMessage(item.value)))
      }
    })])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640f4bfe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Checkbox.vue
// module id = 54
// module chunks = 0